import {STAGE_DISPLAY_SIZES} from '../lib/layout-constants.js';

const SET_STAGE_SIZE = 'scratch-gui/StageSize/SET_STAGE_SIZE';

// console.log(CON_STAGEMODE, window.CON_STAGEMODE)
let stageMode = localStorage.getItem('stageSize') || '1'
if(window.CON_STAGEMODE){
    stageMode = CON_STAGEMODE
}

let stageSizeDefault = STAGE_DISPLAY_SIZES.small
switch (stageMode) {
    case '1':
        stageSizeDefault = STAGE_DISPLAY_SIZES.small;
        break;
    case '2':
        stageSizeDefault = STAGE_DISPLAY_SIZES.large;
        break;
    case '0':
        stageSizeDefault = STAGE_DISPLAY_SIZES.closeStatus;
        break;
    default:
        stageSizeDefault = STAGE_DISPLAY_SIZES.large;
}

const initialState = {
    stageSize: stageSizeDefault
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_STAGE_SIZE:
        return {
            stageSize: action.stageSize
        };
    default:
        return state;
    }
};

const setStageSize = function (stageSize) {
    var mode = 1
    switch (stageSize) {
        case 'small':
            mode = 1
            break;
        case 'large':
            mode = 2
            break;
        case 'closeStatus':
            mode = 0
            break;
        default:
            mode = 2
    }

    localStorage.setItem('stageSize', mode);

    if (typeof (jsObj) === 'object'){
        let json = {
            command: "GEN_STAGEMODE",
            mode: mode
        }
        json = JSON.stringify(json);
        jsObj.SendToBrowser(json);
    }
    
    return {
        type: SET_STAGE_SIZE,
        stageSize: stageSize
    };
};

export {
    reducer as default,
    initialState as stageSizeInitialState,
    setStageSize
};
